export const ANCHORS = {
  CLOUD_TERMS_OF_SERVICE: {
    ID: 'cloud-terms-of-service',
    TITLE: '1. Worklair Cloud Terms of Service',
    SECTIONS: {
      WHAT_THESE_TERMS_COVER: '1.1 What These Terms Cover',
      WHO_CAN_USE_THE_SERVICES_ACCOUNTS:
        '1.2 Who Can Use the Services; Accounts',
      ORDERS_AND_SUBSCRIPTION_TERMS: '1.3 Orders and Subscription Terms',
      FEES_AND_PAYMENT: '1.4 Fees and Payment',
      RIGHTS_TO_USE_THE_SERVICES: '1.5 Rights to Use the Services',
      SENSITIVE_DATA_AND_COMPLIANCE: '1.6 Sensitive Data and Compliance',
      PRIVACY_AND_DATA_PROTECTION: '1.7 Privacy and Data Protection',
      SECURITY_OF_THE_SERVICES: '1.8 Security of the Services',
      OWNERSHIP_AND_PROPRIETARY_RIGHTS: '1.9 Ownership and Proprietary Rights',
      THIRD_PARTY_SERVICES_AND_INTEGRATIONS:
        '1.10 Third-Party Services and Integrations',
      SUSPENSION_AND_TERMINATION: '1.11 Suspension and Termination',
      WARRANTIES_AND_DISCLAIMERS: '1.12 Warranties and Disclaimers',
      LIMITATIONS_OF_LIABILITY: '1.13 Limitations of Liability',
      INDEMNIFICATION: '1.14 Indemnification',
      CHANGES_TO_SERVICES_OR_TERMS: '1.15 Changes to the Services or Terms',
      GOVERNING_LAW_AND_DISPUTE_RESOLUTION:
        '1.16 Governing Law and Dispute Resolution',
      MISCELLANEOUS: '1.17 Miscellaneous',
      PUBLICITY: '1.18 Publicity',
    },
  },
  PRIVACY_POLICY: {
    ID: 'privacy-policy',
    TITLE: '2. Worklair Privacy Policy',
    SECTIONS: {
      WHAT_INFORMATION_WE_COLLECT: '2.1 What Information We Collect',
      HOW_WE_USE_INFORMATION: '2.2 How We Use Information We Collect',
      HOW_WE_SHARE_INFORMATION: '2.3 How We Share Information We Collect',
      HOW_WE_STORE_AND_SECURE_INFORMATION:
        '2.4 How We Store and Secure Information',
      HOW_TO_CONTROL_YOUR_INFORMATION:
        '2.5 How to Access and Control Your Information',
      INTERNATIONAL_TRANSFERS:
        '2.6 How We Transfer Information Internationally',
      OTHER_PRIVACY_INFORMATION: '2.7 Other Important Privacy Information',
      CALIFORNIA_DISCLOSURES:
        '2.8 Additional Disclosures for California Residents',
    },
  },
  SUBPROCESSORS: {
    ID: 'subprocessors',
    TITLE: '3. Subprocessors',
    SECTIONS: {
      OUR_COMMITMENTS: '3.1 Our Commitments Regarding Subprocessors',
      CURRENT_SUBPROCESSORS_LIST: '3.2 Current Subprocessors List',
      CUSTOMER_RIGHTS: '3.3 Customer’s Right to Object to Subprocessors',
      CONTACT_AND_MORE: '3.4 Contact and More Information',
    },
  },
  DATA_PROCESSING_ADDENDUM: {
    ID: 'data-processing-addendum',
    TITLE: '4. Data Processing Addendum (DPA)',
    SECTIONS: {
      DEFINITIONS: '4.1 Definitions',
      DETAILS_OF_PROCESSING: '4.2 Details of Processing',
      OBLIGATIONS_OF_PROCESSOR: '4.3 Obligations of Worklair (Processor)',
      OBLIGATIONS_OF_CONTROLLER: '4.4 Obligations of Customer (Controller)',
      SECURITY_MEASURES: '4.5 Security Measures',
      LIMITATION_OF_LIABILITY: '4.6 Limitation of Liability',
      GENERAL_PROVISIONS: '4.7 General Provisions',
    },
  },
  DATA_TRANSFER_IMPACT_ASSESSMENT: {
    ID: 'data-transfer-impact-assessment',
    TITLE: '5. Data Transfer Impact Assessment',
    SECTIONS: {
      STEP_1: 'Step 1: Know Your Data Transfers',
      STEP_2: 'Step 2: Transfer Mechanism Relied Upon',
      STEP_3: 'Step 3: Assessment of Local Laws and Safeguards',
    },
  },
  USER_NOTICE: {
    ID: 'user-notice',
    TITLE: '6. User Notice',
  },
  ACCEPTABLE_USE_POLICY: {
    ID: 'acceptable-use-policy',
    TITLE: '7. Acceptable Use Policy',
    SECTIONS: {
      DISRUPTION_OF_THE_SERVICE: '7.1 Disruption of the Service',
      WRONGFUL_ILLEGAL_OR_HARMFUL_USE: '7.2 Wrongful, Illegal, or Harmful Use',
      INAPPROPRIATE_COMMUNICATIONS:
        '7.3 Inappropriate Communications (Spam and Harassment)',
      INAPPROPRIATE_CONTENT: '7.4 Inappropriate Content',
      USE_OF_ARTIFICIAL_INTELLIGENCE_FEATURES:
        '7.5 Use of Artificial Intelligence Features',
      OTHER_PROHIBITED_ACTIVITIES: '7.6 Other Prohibited Activities',
      ENFORCEMENT_AND_REPORTING: '7.7 Enforcement and Reporting',
      BE_KIND_AND_USE_COMMON_SENSE: '7.8 Be Kind and Use Common Sense',
    },
  },
  OTHER_LEGAL: {
    ID: 'other-legal',
    TITLE: '8. Other Legal',
    SECTIONS: {
      SOFTWARE_LICENSE_AGREEMENT:
        '8.1 Software License Agreement (On-Premise Software/SDK)',
      GOVERNMENT_AMENDMENT:
        '8.2 Government Amendment (For U.S. Government Users)',
      COOKIES_TRACKING_NOTICE: '8.3 Cookies & Tracking Notice',
      THIRD_PARTY_CODE_NOTICES: '8.4 Third-Party Code Notices',
      COPYRIGHT_INFRINGEMENT_AND_DMCA_POLICY:
        '8.5 Copyright Infringement and DMCA Policy',
      TRADEMARKS_AND_BRAND_USAGE: '8.6 Trademarks and Brand Usage',
      EXPORT_COMPLIANCE: '8.7 Export Compliance',
      MODIFICATIONS_TO_THESE_TERMS: '8.8 Modifications to these Terms',
      ENTIRE_AGREEMENT: '8.9 Entire Agreement',
      CONTACT_INFORMATION: '8.10 Contact Information',
    },
  },
  IMPRESSUM: {
    ID: 'Impressum',
    TITLE: '9. Impressum (Legal Notice / Company Details)',
  },
  ARTIFICIAL_INTELLIGENCE_TERMS: {
    ID: 'artificial-intelligence-terms',
    TITLE: '10. Artificial Intelligence Terms',
    SECTIONS: {
      AI_OFFERINGS_AND_PROVIDERS: '10.1 AI Offerings and Providers',
      RESPONSIBLE_USE_OF_AI:
        '10.2 Responsible Use of AI – Customer Obligations and Restrictions',
      AI_OUTPUT: '10.3 AI Output – Disclaimers and IP',
      CONFIDENTIALITY_OF_INPUTS_OUTPUTS:
        '10.4 Confidentiality of Inputs/Outputs',
      INDEMNITY_FOR_AI_USE: '10.5 Indemnity for AI Use',
      LIMITATIONS_OF_LIABILITY_FOR_AI: '10.6 Limitations of Liability for AI',
      CHANGES_OR_SUSPENSION_OF_AI_FEATURES:
        '10.7 Changes or Suspension of AI Features',
    },
  },
}
